<template>
  <div id="shelvery-service">
    <vue-loading :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>
    <div class="row">
      <div class="column">
        <transition-group name="list" appear>
          <div v-for="account in accountsSorted" :key=account.id>
            <a class="account card" v-bind:class="[accountSelected(account) ? 'selected' : 'unselected']" v-on:click="updateAccount(account)">
              <h5>{{ account.name }}</h5>
              <span v-if="accountSelected(account)" class="timestamp">{{ lastUpdate(shelveryReport, loading) }}</span>
            </a>
          </div>
        </transition-group>
      </div>

      <div class="column">
        <div v-if="shelveryReportSorted.resources">
          <transition-group name="list" appear>
            <div v-for="(resource, index) in shelveryReportSorted.resources" :key=resource.resource.arn>
              <a class="resources card"
                  v-bind:class="[
                    {enabled: shelveryEnabled(resource.config)},
                    {disabled: shelveryDisabled(resource.config)},
                    {notConfigured: !shelveryConfigured(resource.config)},
                    resourceSelected(resource) ? 'selected' : 'unselected']"
                  v-on:click="resourceIndex = index">
                {{ resourceName(resource.resource) }}
              </a>
            </div>
          </transition-group>
        </div>
      </div>

      <div class="column details">
        <div v-if="shelveryReportSorted.resources && shelveryReportSorted.resources.length > 0">
          <transition-group name="fade" appear>
            <div v-for="resource in [shelveryReportSorted.resources[resourceIndex]]" :key=resource.resource.arn>

              <div v-if="resource.config" class="card">
                <h4 class="details">resource details</h4>
                  <dl class="details-dl">
                    <template v-for="(value,key) in resource.resource">
                      <dt :key="key">{{ key }}</dt><dd :key="key">{{ value }}</dd>
                    </template>
                  </dl>
              </div>

              <div v-if="Object.entries(resource.config).length !== 0" class="card">
                <h4 class="config">shelvery config</h4>
                <dl class="config-dl">
                  <template class="config-dl" v-for="(v,k) in resource.config">
                    <dt v-bind:class="[validConfigKey(k) ? 'validKey' : 'invalidKey']" :key="k">{{ k }}</dt><dd :key="k + v">{{ v }}</dd>
                  </template>
                </dl>
              </div>

              <div v-if="Object.entries(resource.snapshots).length !== 0" class="card">
                <h4>shelvery snapshots</h4>
                <div class="list-group list-group-flush" v-for="(snapshots,type) in resource.snapshots" :key="type">
                  <h6>{{ type }}</h6>
                  <li class="list-group-item" v-for="(snapshot, index) in snapshots" :key="snapshot.date_created + '-' + index">
                      {{ snapshot.name }}
                  </li>
                </div>
              </div>

            </div>
          </transition-group>
        </div>
      </div> <!-- column -->
    </div> <!-- row -->
  </div>
</template>

<script>
import HTTP from '@/common/http'
import CONSTANTS from '@/constants/shelvery'
import VueLoading from 'vue-loading-overlay'
import { mapGetters } from 'vuex'

export default {
  name: 'ShelveryService',
  components: {
    VueLoading
  },
  props: [
    'id',
    'type',
    'service'
  ],
  created: function () {
    this.getAccounts()
  },
  data () {
    return {
      shelveryReport: null,
      loading: false,
      accounts: [],
      account: {
        name: 'loading',
        id: null
      },
      resourceIndex: 0,
      error: null
    }
  },
  computed: {
    ...mapGetters([
      'activeType'
    ]),
    shelveryReportSorted: function () {
      if (this.shelveryReport) {
        let report = this.shelveryReport
        let shelveryConfigured = this.shelveryConfigured
        let trueValues = CONSTANTS.TRUE_VALUES
        let falseValues = CONSTANTS.FALSE_VALUES
        report.resources.sort(function (a, b) {
          if (shelveryConfigured(a.config) && trueValues.includes(a.config['shelvery:create_backup']) && !shelveryConfigured(b.config)) {
            return -1
          } else if (shelveryConfigured(a.config) && trueValues.includes(a.config['shelvery:create_backup']) && shelveryConfigured(b.config) && falseValues.includes(b.config['shelvery:create_backup'])) {
            return -1
          } else if (!shelveryConfigured(a.config) && shelveryConfigured(b.config) && falseValues.includes(b.config['shelvery:create_backup'])) {
            return -1
          } else {
            return 1
          }
        })
        return report
      } else {
        return false
      }
    },
    accountsSorted: function () {
      if (this.accounts) {
        let accountsSorted = [...this.accounts]
        accountsSorted.sort(function (a, b) {
          return (a.name === 'prod') < (b.name === 'prod') ? 1 : -1
        })
        return accountsSorted
      } else {
        return null
      }
    }
  },
  watch: {
    id: function () {
      this.getAccounts()
    },
    accounts: function () {
      if (this.accounts.find(account => account.name === 'prod')) {
        this.account = this.accounts.find(account => account.name === 'prod')
      } else {
        this.account = this.accounts[0]
      }
    },
    account: function () {
      this.shelveryReport = null
      this.resourceIndex = 0
      this.getReport()
    },
    service: function () {
      this.shelveryReport = null
      this.resourceIndex = 0
      this.getReport()
    }
  },
  methods: {
    getReport: function () {
      this.loading = true
      HTTP.get(`/shelvery/${this.activeType}/${this.id}/${this.service}/${this.account.id}`)
        .then((response) => {
          this.shelveryReport = response.data.shelvery
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to get Shelvery report : ${error.message}`
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    getAccounts: function () {
      HTTP.get(`/accounts/${this.activeType}/${this.id}`)
        .then((response) => {
          this.accounts = response.data.accounts
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to list account ids for ${this.activeType} ${this.id} : ${error.message}`
          })
        })
    },
    resourceName: function (resource) {
      return (resource.tag) ? resource.tag : resource.name
    },
    shelveryEnabled: function (config) {
      return CONSTANTS.TRUE_VALUES.includes(config[CONSTANTS.CREATE_BACKUP_KEY])
    },
    shelveryDisabled: function (config) {
      return CONSTANTS.FALSE_VALUES.includes(config[CONSTANTS.CREATE_BACKUP_KEY])
    },
    shelveryConfigured: function (config) {
      return CONSTANTS.CREATE_BACKUP_KEY in config
    },
    accountSelected: function (account) {
      return account.id === this.account.id
    },
    resourceSelected: function (resource) {
      return resource === this.shelveryReportSorted.resources[this.resourceIndex]
    },
    validConfigKey: function (key) {
      return CONSTANTS.CONFIG_KEYS.includes(key)
    },
    updateAccount: function (account) {
      this.account = account
      this.resourceIndex = 0
    },
    lastUpdate: function (report, loading) {
      if (report && 'timestamp' in report) {
        let tzoffset = (new Date()).getTimezoneOffset() * 60000 // offset in milliseconds
        let date = (new Date(report.timestamp * 1000 - tzoffset)).toISOString().slice(0, 19).replace('T', ' ')
        return date
      } else if (loading) {
        return 'loading report'
      } else {
        return 'report not found'
      }
    }
  }
}

</script>

<style scoped>

.row {
  display: flex;
  padding: 20px;
}
.column {
  padding: 0px;
  flex-direction: column;
  display: flex;
  overflow: auto;
  flex: 1;
}
.resources {
  text-align: center;
}
.account {
  text-align: center;
}
.timestamp {
  font-size: 9pt;
  color: #aaaaaa;
  margin-bottom: -18px;
  text-align: center;
}
.card {
  transition: opacity 200ms;
  background: #ffffff;
  width: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 15px;
  margin-right: 15px;
  padding: 25px 25px 25px 25px;
  display: flex;
  align-self: center;
  border: none;
  border-radius: 0;
  box-sizing: content-box;
  box-shadow: 0 2px 25px -5px rgba(0,0,0,0.2);
}
.card img {
  left: 0px;
  top: 0px;
  height: 70px;
  width: 90px;
  position: absolute;
}
.enabled {
  border-right: 6px solid #12c998;
}
.disabled {
  border-right: 6px solid #aaaaaa;
}
.notConfigured {
  border-right: 6px solid #f070a1;
}
.selected {
  border-left: 6px solid #77a6f7;
}
.unselected {
  border-left: 6px solid #ffffff;
}
.details {
  flex: 2;
}
.list-group-item {
  border-top: 1px solid rgba(0,0,0,.125);
  border-bottom: 0px solid rgba(0,0,0,.125);
}
h1, h2 {
  font-weight: normal;
  text-align: center;
}
h6 {
  padding-top: 20px;
  font-weight: 800;
}
ul {
  list-style-type: none;
  padding: 0;
  text-align: center;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  cursor: pointer;
}
.config {
  padding-bottom: 20px;
}
.details{
  padding-bottom: 20px;
}
.config-dl {
  display: grid;
  grid-template-columns: auto auto;
  margin: 0px;
}
.details-dl {
  display: grid;
  grid-template-columns: auto auto;
  margin: 0px;
}
dt {
  grid-column-start: 1;
}
dd {
  grid-column-start: 2;
}
.validKey {
  color: #2c3e50;
}
.invalidKey {
  color: #f070a1;
}
.snapshots {
  letter-spacing: 1pt;
}
a:hover {
  transition: all 500ms;
  box-shadow: 0 2px 25px -5px rgba(0,0,0,0.35);
}
.list-item {
  transition: all 200ms;
}
.list-leave-active {
  position: absolute;
}
.list-enter-active {
  transition: transform 200ms, opacity 200ms;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-20px);
}
.list-move {
  transition: transform 500ms;
}
.fade-enter-active {
  transition: opacity 500ms ease-in-out;
}
.fade-enter-to {
  opacity: 1;
}
.fade-enter {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/views/ShelveryService.vue